export const environment = {
  production: true,
  apiUrl: 'https://api-qa.hrci.org/api',
  auth0: {
    domain: 'qalogin.hrci.org',
    clientId: 'G7sURnhYH8ByZvUvj6z4krZYeADdsR9C'
  }
};
